import { gql } from '@apollo/client'

export const TOGGLE_USER_NOTIFICATIONS = gql`
  mutation ToggleUserNotifications($inputData: ToggleUserNotificationInput!) {
    toggleUserNotification(inputData: $inputData)
  }
`
